import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'
import requestAddBlocker from 'store/sagas/requestAddBlocker'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  ButtonGroup,
  HelpBlock,
} from 'react-bootstrap'
import Button from 'components/Button'
import blockerType from 'const/blockerType'
import { BLOCKER_NAME_MAX_LENGTH, BLOCKER_DESCRIPTION_MAX_LENGTH } from 'const/limits'
import trimRichText from 'components/RichText/utils/trim'
import getCharCount from 'components/RichText/utils/getCharCount'
import RichTextEditor from 'components/RichText/Editor'

const initialValues: {
  name: string;
  description?: any;
} = {
  name: '',
  description: undefined,
}

const AddGlobalBlocker: React.FC<LeftSidebarProps> = ({
  leftSidebar
}) => {
  const dispatch = useDispatch()

  const intl = useIntl()

  const close = () => {
    leftSidebar.pop()
  }

  return (
    <LeftSidebarView
      title={<FormattedMessage id='BLOCKERS_GLOBAL_ADD_TITLE' />}
    >
      <ViewBody>
        <Formik
          initialValues={initialValues}
          validate={({ name, description }) => {
            const errors: any = {}
  
            if (name.length > BLOCKER_NAME_MAX_LENGTH) {
              errors.name = intl.formatMessage({ id: 'BLOCKERS_NAME_TOO_LONG' }, { limit: BLOCKER_NAME_MAX_LENGTH })
            }

            if (getCharCount(description) > BLOCKER_DESCRIPTION_MAX_LENGTH) {
              errors.description = intl.formatMessage({ id: 'BLOCKERS_DESCRIPTION_TOO_LONG' }, { limit: BLOCKER_DESCRIPTION_MAX_LENGTH })
            }
        
            return errors
          }}
          onSubmit={({ name, description }) => {
            if (name) {
              dispatch(requestAddBlocker({
                name,
                type: blockerType.GLOBAL,
                description: description ? trimRichText(description) : undefined,
              }))
            }

            close()
          }}
        >
          {({ handleSubmit, handleChange, handleBlur, values, errors, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <FormGroup
                validationState={errors.name ? 'error' : null}
              >
                <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
                <FormControl
                  autoFocus
                  type='text'
                  name='name'
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.name && <HelpBlock>{errors.name}</HelpBlock>}
              </FormGroup>
              <FormGroup
                validationState={errors.description ? 'error' : null}
              >
                <ControlLabel><FormattedMessage id='DESCRIPTION' /></ControlLabel>
                <RichTextEditor
                  content={values.description}
                  onChange={(content) => {
                    setFieldValue('description', content)
                  }}
                />
                {errors.description && <HelpBlock>{errors.description}</HelpBlock>}
              </FormGroup>
              <ButtonGroup>
                <Button type='submit' bsStyle='primary' disabled={isSubmitting}><FormattedMessage id='ADD' /></Button>
                <Button onClick={close}><FormattedMessage id='CANCEL' /></Button>
              </ButtonGroup>
            </form>
          )}
        </Formik>
      </ViewBody>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(AddGlobalBlocker)